<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="10" offset-md="1" v-for="(item) in portfolio" :key="item">
        <v-row>
          <v-col>
          <v-card elevation="0">
            <v-card-title class="text-center justify-center py-6">
              <h1 class="black--text title">{{item.name}}</h1>
            </v-card-title>
            <v-tabs fixed-tabs :centered="true" color="black">
              <v-tab>Detail</v-tab>
              <v-tab>Screenshots</v-tab>
              
              <v-tab-item>
                <v-card elevation="0" class="pa-6">
              <v-card-title class="subtitle-1">
                {{ item.description}}
              </v-card-title>
              <v-card-subtitle class="subtitle-1">
                <div>
                  Platform: <v-icon v-for="icon in item.icons" :key="icon">{{icon}}</v-icon>
                </div>
              </v-card-subtitle>
              <v-card-text>
                <blockquote class="blockquote">
                  {{item.detail}}
                </blockquote>
              </v-card-text>
              <v-card-actions>
                <v-btn
                 v-for="action in item.actions"
                  :key="action"
      color="grey"
      outlined
      class="ma-2 white--text"
                  :href="action.link" 
                  target="_blank"

    >
      <v-icon left dark>mdi-exit-to-app</v-icon>
      {{ action.label}}
    </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item class="pa-4">
                <carousel-3d :loop="true" @after-slide-change="onAfterSlideChange" :controls-visible="true" :width="300" :height="500" :display="5">
                  <slide v-for="(img_name,i) in item.imgCount"  :key="i" :index="i">
                      <img :src="'/img/' + item.id + '/' + item.append + img_name + '.png'">
                      <figcaption class="body-1 text-center">{{ item.imgCaptions[i] }}</figcaption>

                  </slide>
                </carousel-3d>
              </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</v-col>
</v-row>
<div id="example">
        
      </div>
  </v-container>
</template>

<script>

import {Carousel3d, Slide } from 'vue-carousel-3d';
//import KiriLiveComponent from './KiriLiveAppComponent';
//import BokinAneneAppComponent from './BokinAneneAppComponent';

export default {
  name: 'HelloWorld',
  components: {
    Carousel3d,
    Slide
  },
  data: () => ({
    text: "test",
    dialog: false,
    selectedComponent: "KiriLiveComponent",
    slides: 7,
    portfolio: [
      {
        id: 1,
        imgCaptions: [
          "Media Player started state when media fully load stream data.",
          "Phone state permission required since the media player needs to be able to manage its state.",
          "Using the android sharesheet to share this app with other apps.",
          "Alert dialogs that display the user options upon clicking the stop button.",
          "Alert dialogs that display the push notification message inside the app.",
          "Media Player preparing state when loading the media source over the network.",
          "Ongoing notification that can interact with media player service using the action defined in the intent.",
          "Record audio permission is requred for displaying audio visualizer.",
          "Alert dialog showing the reason for requiring record audio permission.",
          "Permission dialog after clicking the 'Accepting."

        ],
        color: "yellow--text text--darken-2",
        name: 'Kiribati Radio Live',
        component: "KiriLiveComponent",
        description: 'Kiribati Radio Live App for the latest news and music from Kiribati',
        detail: 'Kiribati Radio Live is an app that allows Kiribati community everywhere around the world to use their phone ' +
        'to listen to the radio, broadcasting local news and music from Kiribati over the internet.',
        img: "/img/1/main.png",
        icons: [ "mdi-android", "mdi-cellphone-android"],
        imgCount: 9,
        append: "radioscreenshot",
        actions: [
          {
            label: "Visit",
            link: "https://play.google.com/store/apps/details?id=radio.softdev.sok.com.kiribatiradiolive&hl=en"
          }
        ]

      },
      {
        id: 2,
        imgCaptions: [
          "Sign in activity",
          "Signing in using google sign in provider",
          "Splash screen",
          "Main Activity showing main search fragment",
          "Searching hymn by hymn number",
          "Hymn search result fragment showing the result of the search by hymn number",
          "Recycle view displaying a list of hymns matching hymn searched by keyword",
          "Hymn search result fragment showing the hymn selected from list",
          "",
          "App main navigation drawer"
        ],
        color: "red--text text--darken-2",
        name: 'Boki n Anene',
        component: "BokinAneneAppComponent",
        description: 'Christian Hymn Book digital version of the "Boki n Anene" book that contains 314 hymns',
        img: "/img/2/bokinaneneapp.png",
        imgCount: 11,
        append: "bokinanene",
        icons: [ "mdi-android", "mdi-cellphone-android"],
        detail: "Boki n Anene is an app version of the actual church hymn book used by Kiribati people in Kiribati and " +
            "around the world. This app provides the functionality of searching hymn by " +
            "hymn number or keyword that makes searching for hymn super easy and fast.",
            actions: [
          {
            label: "Visit",
            link: "https://play.google.com/store/apps/details?id=app.codenert.co.nz.bokinanene&hl=en"
          }
        ]
      },
      {
        id: 3,
        imgCaptions: [
          "Navigation drawer activated when this web app open on a mobile device",
          "Login page",
          "Page to search for the hymn by hymn number",
          "Search result showing the hymn and hymn number inside the textbox",
          "Dialog showing the edit warning message",
          "Dialog showing the delete warning message",
          "Page to add new hymn",
          "Profile page",
          "Page to register new web app user",
          "",

        

        ],
        name: 'Boki n Anene Web Admin App',
        color: "green--text",
        component: "KiriLiveComponent",
        description: 'Admin website for Boki n Anene',
        detail: "Restricted admin website to manage all the hymns data for the 'Boki n Anene' app. Admin user can login and create the hymn, get the hymn, delete the hymn and edit " +
        "the hymn.",
        img: "/img/3/bokinanenewebadmin.png",
        imgCount: 12,
        append: "bokinanenewebapp",
        icons: ["mdi-web"],
        actions: [
          {
            label: "Visit",
            link: "https://bokinanene.codenertapps.com"
          }
        ]
      },
    ]
  }),
  methods: {
    fullDetail: function(component) {
      this.dialog = true
      this.selectedComponent = component
    },
    onAfterSlideChange(index)  {
      this.text = "fasfsd" + index
    }
  }
};
</script>

<style scoped>
.carousel-3d-container figure {
  margin:0;
}

.carousel-3d-container figcaption {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  bottom: 0;
  position: absolute;
  bottom: 0;
  padding: 15px;
  font-size: 12px;
  min-width: 100%;
  box-sizing: border-box;
}
</style>
